module.exports = __webpack_public_path__ + "assets/img/404_wechat.8e0792e9.svg";